<span class="label" [class.required]="requiredAsterisk && required && label">{{ label }}</span>
<mat-form-field class="country-selector" appearance="outline" color="accent">
	<input
		type="text"
		autocomplete="off"
		[placeholder]="'sf.shared_component.country_select.placeholder' | translate"
		[formControl]="inputControl"
		[disabled]="disabled"
		matInput
		[matAutocomplete]="auto"
		(input)="onInput($event)"
	/>
	<mat-autocomplete
		#auto="matAutocomplete"
		class="sf-select"
		(optionSelected)="optionSelected($event)"
		[displayWith]="displayFn.bind(this)"
	>
		<mat-option *ngFor="let country of filteredCountryList | async" [value]="country.iso">
			{{ country.iso | countryName | async }}
		</mat-option>
	</mat-autocomplete>
	<mat-error *ngIf="inputControl.hasError('required')">{{
		'sf.common.validation.errors.field_required' | translate
	}}</mat-error>
	<mat-error *ngIf="inputControl.hasError('wrongCountryName')">{{
		'sf.common.validation.errors.field_wrong_country' | translate
	}}</mat-error>
</mat-form-field>
